import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/api/v1/auth';
import Home from '@/views/Home';
import Login from '@/views/Auth/Login';
import UserProfile from '@/views/User/UserProfile';
import PrevResults from '@/views/Game/PreviousResults';
import BuldingBlocks from '@/views/Game/BuldingBlocks/Index';
import ReportMyResults from '@/views/Game/ReportMyResults';
import StudentsList from '@/views/Game/ListOfStudents/Index';
import StudentsResultList from '@/views/Game/StudentsResultList';
import Results from '@/views/Game/Results/Index';
import TechnicalSupport from '@/views/StaticPages/TechnicalSupport';
import LearnMore from '@/views/StaticPages/LearnMore';
import AccountDetails from '@/views/User/AccountDetails';
import Careers from '@/views/StaticPages/Careers';
import ContactUs from '@/views/ContactUs/Index';
import ScienceInSchool from '@/views/ScienceInSchool/Index';
import News from '@/views/News/Index';
import AskScientist from '@/views/AskScientist/Index';
import ForgotPassword from '@/views/Auth/ForgotPassword';
import ILoveScience from '@/views/ILoveScience';
import NeedToKnow from '@/views/NeedToKnow';
import Search from '@/views/Search/Search';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/user_profile',
      name: 'user_profile',
      component: UserProfile,
      meta: { requiresAuth: true },
    },
    {
      path: '/prev_results',
      name: 'prev_results',
      component: PrevResults,
      meta: { requiresAuth: true },
    },
    {
      path: '/building_blocks',
      name: 'building_blocks',
      component: BuldingBlocks,
      meta: { requiresAuth: true },
    },
    {
      path: '/building_blocks/edit/:experimentId',
      name: 'edit_building_blocks',
      component: BuldingBlocks,
      meta: { requiresAuth: true },
    },
    {
      path: '/report_my_results',
      name: 'report_my_results',
      component: ReportMyResults,
      meta: { requiresAuth: true },
    },
    {
      path: '/students_list',
      name: 'students_list',
      component: StudentsList,
      meta: { requiresAuth: true },
      // Redirect to home page if not teacher
      beforeEnter: (to, from, next) => {
        if (auth.user.user_type !== 'teacher') {
          next({ name: 'home' });
        } else {
          next();
        }
      },
    },
    {
      path: '/students_result_list/:studentId',
      name: 'students_result_list',
      component: StudentsResultList,
      meta: { requiresAuth: true },
    },
    {
      path: '/results/:experimentId',
      name: 'results',
      component: Results,
      meta: { requiresAuth: true },
    },
    {
      path: '/results/show/:experimentId',
      name: 'show_results',
      component: Results,
      meta: { requiresAuth: true },
    },
    {
      path: '/support',
      name: 'support',
      component: TechnicalSupport,
    },
    {
      path: '/learn_more',
      name: 'learn_more',
      component: LearnMore,
    },
    {
      path: '/account_details',
      name: 'account_details',
      component: AccountDetails,
      meta: { requiresAuth: true },
    },
    {
      path: '/careers',
      name: 'careers',
      component: Careers,
    },
    {
      path: '/contact_us',
      name: 'contact_us',
      component: ContactUs,
    },
    {
      path: '/i_love_science/:articleId',
      name: 'i_love_science',
      component: ILoveScience,
    },
    {
      path: '/need_to_know/:articleId',
      name: 'need_to_know',
      component: NeedToKnow,
    },
    {
      path: '/science_in_school',
      name: 'science_in_school',
      component: ScienceInSchool,
    },
    {
      path: '/news',
      name: 'news',
      component: News,
    },
    {
      path: '/ask_a_scientist',
      name: 'ask_a_scientist',
      component: AskScientist,
    },
    {
      path: '/password_reset',
      name: 'password_reset',
      component: ForgotPassword,
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
  scrollBehavior() {
    return { selector: '#scrollToOnLoad' };
  },
});

router.beforeEach((to, from, next) => {
// Check if entered route needs authentication, then check if user is logged in
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.user.authenticated) {
      next({
        name: 'login',
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js